import React from 'react'
import Header from '../Header/Header'
import Hero from '../Hero/Hero';
import Footer from '../Footer/Footer';

function Plus() {
  return (
    <div>
        <div>
          <div className="white-gradient"/>
          <Header/>
          <Hero/>
        </div>
        {/* <Footer/> */}
    </div>
  )
}

export default Plus